import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegisterModel } from '../../../model/register-model';
import { AuthService } from '../../../services/auth.service';
import { SharedModule } from '../../../shared/shared-module.ts.module';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, SharedModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  form: FormGroup;
  clientId: string | null = null;

  constructor(private authService: AuthService, private fb: FormBuilder, private router: Router, private spinner: NgxSpinnerService) {
    this.clientId = this.authService.getClienteIdLocal();

    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(128)]],
      confirmPassword: ['', Validators.required],
    }, { validators: RegisterComponent.passwordsMatch });
  }

  private static passwordsMatch(control: AbstractControl): ValidationErrors | null {
    return control.get('password')?.value === control.get('confirmPassword')?.value
      ? null
      : { passwordsMismatch: true };
  }


  create() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const clientId = this.authService.verificaClientId(this.clientId ?? '');
    if (clientId === null) {
      alert('Cliente invalido. Inicie o cadastro pelo sistema que deseja acessar.');
      return;
    }
    this.spinner.show();
    const model: RegisterModel = {
      name: this.form.value.name.trim(),
      email: this.form.value.email.trim().toLowerCase(),
      password: this.form.value.password,
      clientId,
    };

    this.authService.create(model).subscribe({
      next: (response) => {
        this.router.navigate(['/login']);
        this.spinner.hide();
      },
      error: (error) => {
        alert("Erro ao cadastrar usuário");
        this.spinner.hide();
        console.error(error);
      },
    });
  }
}
